// extracted by mini-css-extract-plugin
export var boxItems = "_aj-1";
export var boxItemsLg = "_aj-2";
export var button = "_aj-7";
export var buttonHoverless = "_aj-9";
export var buttonLg = "_aj-8";
export var filterGroupBox = "_aj-0";
export var icon = "_aj-3";
export var iconSecondary = "_aj-6";
export var iconWrapper = "_aj-4";
export var iconWrapperLg = "_aj-5";
export var truncatedLabel = "_aj-a";